import Schema from '../Schema';

const AudioContents = new Schema({
  _id: String,

  // タイトル
  title: {
    en_us: String,
    ja_jp: String
  },
  // 説明
  description: {
    en_us: String,
    ja_jp: String
  },
  // 著者名
  authors: [
    {
      en_us: String,
      ja_jp: String
    }
  ],
  // 声優名
  narrators: [
    {
      en_us: String,
      ja_jp: String
    }
  ],
  // ジャケット画像
  image: {
    source: String,
    coordinates: String,
    height: Number,
    width: Number
  },
  // 総再生時間
  play_time: Number,
  // チャプター情報
  chapters: [
    {
      title: { en_us: String, ja_jp: String },
      play_time: Number,
      source: String
    }
  ],
  // 音源データパス
  source: String,
  // 参照データパス,
  extra: [{ title: { en_us: String, ja_jp: String }, source: String }],
  // サンプル音源
  sample: {
    // サンプル音源データパス
    source: String,
    // サンプル音源データ再生時間
    play_time: Number
  },
  // 前回の再生位置の記録
  audio_content_progress: {
    chapter_index: Number,
    seek: Number,
    rate: Number
  }
});

AudioContents.getTitle = (content) => {
  return content.title.en_us || content.title.ja_jp;
};

AudioContents.getDescription = (content) => {
  return content.description.en_us || content.description.ja_jp;
};

AudioContents.getAuthorNames = (content) => {
  const names = content.authors.map((v) => {
    return v.en_us || v.ja_jp;
  });
  return names;
};

AudioContents.getNarratorNames = (content) => {
  const names = content.narrators.map((v) => {
    return v.en_us || v.ja_jp;
  });
  return names;
};

export default AudioContents;
